// extracted by mini-css-extract-plugin
module.exports = {"vendorListGroupWrapper":"JglbrmzeUM2tSrGmp4MhU","vendorListGroupItemWrapper":"_2juipBpJw-yjS7PGN_C_DC"};